export const formatNavValue = (id?: string | null, name?: string | null) => {
    if (!id && !name) return '';
    if (id && name) return `${name} (${id})`;
    return id ?? name ?? '';
};

export const formatDateTime = (value?: string | null) => {
    if (!value) return '';
    return new Date(value).toLocaleString();
};

export const formatDateOnly = (value?: string | null) => {
    if (!value) return '';
    return value;
};

export const formatBoolean = (value?: boolean | null) => {
    if (value === null || value === undefined) return '';
    return value ? 'true' : 'false';
};
